import styled from "styled-components";
import { Dialog } from "@mui/material";

const ScrollDesignDialog = styled(Dialog)`
    && .MuiDialog-paper {
        max-width: calc(100vw - 2rem);
        max-height: 88vh;
        border: 1px solid #C9D2E7;
        border-radius: 16px;
        box-shadow: 0 28px 70px rgba(0, 0, 0, 0.28);
        overflow: hidden;
        background: linear-gradient(180deg, #ffffff 0%, #f7f9fd 100%);
        color: #171A22;
        font-family: Manrope, Helvetica, sans-serif;
    }

    && .MuiDialog-paper h1,
    && .MuiDialog-paper h2,
    && .MuiDialog-paper h3 {
        color: #171A22;
        font-family: Manrope, Helvetica, sans-serif;
        letter-spacing: 0;
    }

    && .MuiDialog-paper input,
    && .MuiDialog-paper textarea,
    && .MuiDialog-paper select {
        border-radius: 8px;
        box-shadow: none !important;
        max-width: 100%;
        box-sizing: border-box;
    }

    && .MuiDialog-paper button {
        border-radius: 8px;
        box-shadow: none !important;
    }

    && *::-webkit-scrollbar {
        width: 0.375rem;
        height: 0.5rem;
        border-radius: 0.375rem;
        border-right: none;
        border-left: none;
    }

    && *::-webkit-scrollbar-thumb {
        background-color: #DBE5ED;
        border-radius: 0.375rem;
    }

    && *::-webkit-scrollbar-track {
        margin-top: 2.5rem;
        margin-left: 1.875rem;
    }

    && *::-webkit-scrollbar-track-piece:start {
        background-color: #FFFFFF;
        border-radius: 0.375rem;
    }

    && *::-webkit-scrollbar-track-piece:end {
        background-color: #FFFFFF;
        border-radius: 0.375rem;
    }
`;

export default ScrollDesignDialog;
